import { MijnRouteKey } from '@ap/mijn-navigatie';

export const RESET_ROUTE_KEYS = [MijnRouteKey.OVERVIEW, MijnRouteKey.SELF_SERVICE, MijnRouteKey.CONTACT];

export const MAX_BUTTON_TEXTLENGTH_FOR_ROW_LAYOUT = 25;

export const CONVERSATIONAL_CONFIGURATION_NAME = 'show-contact-conversational';
export const NEXTBESTACTION_SESSIONNAME = 'nba';
